import React from 'react';

import { UiKit } from 'components';
import { ReactComponent as LinkIcon } from 'assets/img/icons/external-link.svg';

export default function NbnlTncContent({
  agreeTerms = false,
  setAgreeTerms = () => {}
}) {
  return (
    <>
      <p>Terms of Service</p>
      <UiKit.Checkbox
        checked={agreeTerms}
        onChange={val => setAgreeTerms(val)}
        className="mb-2"
        label="I have read and agree to the following terms of service:"
      >
        <div>
          <a
            href="https://www.ups.com/assets/resources/webcontent/en_US/ups_dap_supplemental_tc.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            UPS Supplemental Terms and Conditions for Service <LinkIcon />
          </a>
        </div>

        <div>
          <a
            href="https://www.ups.com/us/en/support/shipping-support/shipping-special-care-regulated-items/prohibited-items"
            target="_blank"
            rel="noopener noreferrer"
          >
            List of Prohibited Items <LinkIcon />
          </a>
        </div>
      </UiKit.Checkbox>
    </>
  );
}
